import { render } from "./smallFldsRadarChart.vue?vue&type=template&id=27c5aa82&scoped=true"
import script from "./smallFldsRadarChart.vue?vue&type=script&lang=js"
export * from "./smallFldsRadarChart.vue?vue&type=script&lang=js"

import "./smallFldsRadarChart.vue?vue&type=style&index=0&id=27c5aa82&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c5aa82"]])

export default __exports__